import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import { JSString } from 'kts-scaffold-framework/utils/kit';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Input, Select, Button, Icon, Checkbox, Divider } from 'antd';
import { Decorators } from 'kts-scaffold-framework/utils/doc';

const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 13 },
};

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}
@create()
/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class CompanyRegistration extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillMount() {
        ModulesAction.getCountry();
        ModulesAction.getProvince('CHN');
        ModulesAction.checkCompany(JSString.getQueryString(location.search, 'ticket'));
    }
    render() {
        const { match } = this.props; // 获取你的props数据
        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator } = form;
        return (
                <div className={css.companyRegister}>
                    <div className={css.header}>
                        <img src={require('./IMG.LogText.png')}/>
                    </div>
                    <div className={css.register}>
                        <div className={css.title}>欢迎注册</div>
                        <div className={css.container}>
                            <Form 
                                onSubmit={this.handleSubmit}
                            >
                                <div className={css.sTitle}>账户信息</div>
                                <FormItem label="登录用户名" {...formItemLayout}>
                                    <div className={css.userName}>{this.state.info.email ? this.state.info.email : '该链接已过期'}</div>
                                    <div className={css.notice}>电子邮箱是您的登录用户名。您也可以通过电子邮箱接收系统消息和重置密码</div>
                                </FormItem>
                                {this.state.info.adminActived === '0' && (
                                    <FormItem label="请输入密码" {...formItemLayout}>
                                    {getFieldDecorator('password', {                 
                                        rules: [{
                                            required: true,
                                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
                                            message: "由字母加数字构成,区分大小写，长度为6位以上",
                                            whitespace: true
                                        }],
                                    })(
                                        <Input 
                                            placeholder="请输入密码"
                                            type={this.state.ispwdOpen ? 'text' : 'password'}
                                            suffix={
                                                <Icon 
                                                    type={this.state.ispwdOpen ? 'eye' : 'eye-o'} 
                                                    style={{ color: 'rgba(0,0,0,.25)' }}
                                                    onClick={ModulesAction.handlePwdShow}
                                                />
                                            }
                                        />
                                    )}
                                    </FormItem>
                                )}                       
                                <FormItem label="公司全称" {...formItemLayout}>
                                {getFieldDecorator('name', {
                                    initialValue: this.state.info.companyName,
                                    rules: [{
                                    required: true, message: '公司名称不能为空',
                                    }, {validator: this.companyNameCheck}],
                                })(
                                    <Input placeholder="公司工商注册名称"/>
                                )}
                                </FormItem>
                                <FormItem label="公司纳税人识别号" {...formItemLayout}>
                                {getFieldDecorator('taxId', {
                                    initialValue: this.state.info.taxId,
                                    rules: [{ 
                                        type: 'string', 
                                        pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/, 
                                        required: true, message: '15或17或18或20位大写字母字母、数字组成', 
                                        whitespace: true }, {validator: this.companyTaxidCheck}],
                                })(
                                    <Input placeholder="请输入公司纳税人识别号"/>
                                )}
                                </FormItem>
                                <div className={css.sTitle}>详细信息</div>
                                <FormItem label="公司联系人" {...formItemLayout}>
                                {getFieldDecorator('contactName', {
                                    initialValue: this.state.info.contactName,
                                })(
                                    <Input placeholder="公司联系人姓名" disabled={true}/>
                                )}
                                </FormItem>
                                <FormItem label="联系电话" {...formItemLayout}>
                                {getFieldDecorator('phone', {
                                    initialValue: this.state.info.contactPhone,
                                    rules: [
                                        {
                                            type: 'string',
                                            required: false,
                                            pattern: /^([\d|\-]{0,20})$/,
                                            message: '数字或数字加“-”'
                                        }
                                    ]                                   
                                })(
                                    <Input placeholder="公司联系人电话"/>
                                )}
                                </FormItem>
                                <FormItem label="所在国家或地区" {...formItemLayout}>
                                {getFieldDecorator('country', {
                                    initialValue: this.state.info.location.country
                                })(
                                    <Select
                                        showSearch={true}
                                        placeholder="所在国家或地区"
                                        optionFilterProp="children"
                                        onSelect={this.changeCountry}
                                    >
                                        {this.countryList()}
                                    </Select>
                                )}
                                </FormItem>
                                {this.state.isChina && (
                                <FormItem label="所在省市" {...formItemLayout}>
                                <div className={css.cityCont}>
                                    {getFieldDecorator('state', {
                                        initialValue: this.state.info.location.state
                                    })(
                                        <Select
                                            showSearch={true}
                                            placeholder="所在省"
                                            optionFilterProp="children"
                                            className={css.city}
                                            onSelect={this.changeState}
                                        >
                                            {this.provinceList()}
                                        </Select>
                                    )}
                                    {getFieldDecorator('city', {
                                        initialValue: this.state.info.location.city
                                    })(
                                        <Select
                                            showSearch={true}
                                            placeholder="所在区"
                                            optionFilterProp="children"
                                            className={css.city}
                                        >
                                            {this.cityList()}
                                        </Select>
                                    )}
                                </div>
                                </FormItem>
                                )
                                }
                                <FormItem label="详细地址" {...formItemLayout}>
                                {getFieldDecorator('address', {
                                    initialValue: this.state.info.location.address
                                })(
                                    <Input placeholder="详细的企业联系地址"/>
                                )}
                                </FormItem>                       
                                <div className={css.file}>
                                    <Checkbox onChange={ModulesAction.agree}>
                                        我已阅读并同意<a target="_blank" href="/serviceagreement">《网站服务协议》</a> | <a target="_blank" href="/privacyagreement">《隐私政策》</a>
                                    </Checkbox>
                                </div>
                                <Divider/>
                                <div className={css.actionCont}>
                                    <Button type="primary" htmlType="submit" disabled={!this.state.isAgree}>注册</Button>
                                    <Button onClick={() => ModulesAction.go('/login')}>放弃</Button>
                                </div>
                            </Form> 
                        </div>
                    </div>
                </div>
        );
    }
    /** 拼接国家列表 */
    private countryList = () => {
        let list = [];
        if (this.state.countryList) {
            this.state.countryList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接省列表 */
    private provinceList = () => {
        let list = [];
        if (this.state.provinceList) {
            this.state.provinceList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接市列表 */
    private cityList = () => {
        let list = [];
        if (this.state.cityList) {
            this.state.cityList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /**
     * 获取表单信息
     */
    private handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {        
            if (!err) {
                ModulesAction.activeCompany(values);
            }
        });
        
    }
    /** 国家下拉框改变 */
    private changeCountry = (va, opt) => {
        this.props.form.setFieldsValue({ state: undefined, city: undefined });
        ModulesAction.countryChange(opt.key);
    }
        /** 省下拉框改变 */
    private changeState = (va, opt) => {
        this.props.form.setFieldsValue({ city: undefined });
        ModulesAction.provinceChange(opt.key);
    }
    private companyNameCheck = async (rule, value, callback) => {
        const companyName = this.props.form.getFieldValue('name');
        if (companyName) {
            const res = await ModulesAction.registryInfoCheck({
                companyName,
                companyId: this.state.info.companyId
            });
            if(res && !res.result) {
                callback(res.message);
            } else {
                callback();
            }
        }    
    }

    private companyTaxidCheck = async (rule, value, callback) => {
        const companyTaxid = this.props.form.getFieldValue('taxId');
        const reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
        const companyTaxidMacth = reg.test(companyTaxid);
        if (companyTaxidMacth && companyTaxid && (companyTaxid.length === 15 || companyTaxid.length === 17 || companyTaxid.length === 18 || companyTaxid.length === 20 )) {
            const res = await ModulesAction.registryInfoCheck({
                companyTaxid,
                companyId: this.state.info.companyId
            });
            if(res && !res.result) {
                callback(res.message);
            } else {
                callback();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/CompanyRegister/UI.Register.tsx